import appAndPages from './app-and-pages'

// Array of sections
export default [...appAndPages]
